export default __webpack_public_path__ + "static/media/seta.bd245421.svg";